import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { MainTableFilterModulesEnum } from 'src/app/core/enums/main-table-filter-modules.enum';
import { ApiResponse } from 'src/app/core/models/api-response';
import { defaultPageSizes } from 'src/app/core/table-config/table-paging-defaults';
import { getTenantId } from 'src/app/services/store-snapshot.service';
import { createFilterParams } from 'src/app/shared/functions/create-filter-params';
import { IdName } from 'src/app/shared/models/id-name';
import { MainTableFilterModel } from 'src/app/shared/models/main-table-filter.model';
import { environment } from 'src/environments/environment';
import { IExposureDuration } from '../models/exposure-duration.model';

const headers = { 'content-type': 'application/json' };

@Injectable({
  providedIn: 'root',
})
export class ExposureDurationApiService {
  private get url(): string {
    return `${environment.apiUrl}/api/${getTenantId()}/Product/ExposureDuration`;
  }

  constructor(private http: HttpClient) {}

  loadExposureDurations(
    currentFilter?: MainTableFilterModel
  ): Observable<ApiResponse<IExposureDuration[]>> {
    const params = createFilterParams(currentFilter);

    return this.http.get<ApiResponse<IExposureDuration[]>>(this.url, { params });
  }

  loadAllExposureDurations(): Observable<IdName[]> {
    return this.http.get<IdName[]>(`${this.url}/All`);
  }

  loadExposureDurationById(id: string): Observable<IExposureDuration | undefined> {
    const filter = new MainTableFilterModel(MainTableFilterModulesEnum.ExposureDurations);
    filter.pageSize = defaultPageSizes[defaultPageSizes.length - 1];

    return this.loadExposureDurations(filter).pipe(
      map((response) => response.data?.find((item) => item.id === id))
    );
  }

  createExposureDuration(exposureDuration: IExposureDuration): Observable<IExposureDuration> {
    return this.http.post<IExposureDuration>(
      this.url,
      {
        name: exposureDuration.name,
        sortOrder: exposureDuration.sortOrder,
      },
      { headers }
    );
  }

  updateExposureDuration(exposureDuration: IExposureDuration): Observable<IExposureDuration> {
    return this.http.put<IExposureDuration>(
      `${this.url}/${exposureDuration.id}`,
      {
        name: exposureDuration.name,
        sortOrder: exposureDuration.sortOrder,
      },
      { headers }
    );
  }

  deleteExposureDuration(id: string): Observable<void> {
    return this.http.delete<void>(`${this.url}/${id}`);
  }
}
